import { CLASSES } from '../utils/constants';
import { toggleHtmlClass } from '../utils/domHelpers';

const CONTRAST_CLASS_MAP = {
  darkContrast: CLASSES.darkContrast,
  lightContrast: CLASSES.lightContrast,
  highContrast: CLASSES.highContrast,
  invertColors: CLASSES.invert,
  monochrome: CLASSES.monochrome,
  highSaturation: CLASSES.highSaturation,
  lowSaturation: CLASSES.lowSaturation,
};

const MAIN_MODES = ['darkContrast', 'lightContrast', 'highContrast'];
const MAIN_CLASSES = MAIN_MODES.map((k) => CONTRAST_CLASS_MAP[k]);

export function applyContrast(key, enabled) {
  const cls = CONTRAST_CLASS_MAP[key];
  if (!cls) return;

  if (MAIN_MODES.includes(key) && enabled) {
    MAIN_CLASSES.forEach((c) => {
      if (c !== cls) document.documentElement.classList.remove(c);
    });
  }

  toggleHtmlClass(cls, enabled);
}

export function removeAllContrast() {
  Object.values(CONTRAST_CLASS_MAP).forEach((c) => {
    document.documentElement.classList.remove(c);
  });
}
